import { IonSlide, IonSlides } from '@ionic/react'
import { documentTextOutline } from 'ionicons/icons'
import { useRef } from 'react'
import { Empty } from '../../layouts/errors/Empty'
import Description from './Description'
import './Updates.css'

interface Props {
    data: Array<string>,
    changeSubTitle: any
}

const Updates: React.FC<Props> = (props) => {
    let index = 0;

    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const slideOpts = {
        initialSlide: 0,
        speed: 200
    }

    const changeSliderHandler = async () => {
        const slideIndex = await sliderRef.current?.getActiveIndex()
        let slideItem = props.data[slideIndex!] as any;
        props.changeSubTitle(slideItem['date']);
    }

    return <Empty text="گزارشی ثبت نشده است!" icon={documentTextOutline} length={props.data?.length}>
        <IonSlides className="updates" pager={props.data?.length > 1} ref={sliderRef} options={slideOpts} onIonSlideDidChange={changeSliderHandler}>
            {props.data?.map((item: any) => {
                return <IonSlide key={index++}>
                    <Description content={item['description'] as string} />
                </IonSlide>
            })}
        </IonSlides>
    </Empty>
}

export default Updates